import { useState } from 'react';

const ADMIN_CREDENTIALS = {
  username: 'admin',
  password: 'ungdo123'
};

function AdminLogin({ onLogin }) {
  const [credentials, setCredentials] = useState({ username: '', password: '' });
  const [error, setError] = useState('');

  const handleSubmit = (event) => {
    event.preventDefault();

    if (
      credentials.username.trim() === ADMIN_CREDENTIALS.username &&
      credentials.password === ADMIN_CREDENTIALS.password
    ) {
      localStorage.setItem('ungdo-admin-auth', 'true');
      onLogin();
      return;
    }

    setError('Invalid username or password.');
  };

  return (
    <div className="admin-auth-shell">
      <div className="admin-auth-card">
        <p className="eyebrow">Restricted area</p>
        <h2>Admin login</h2>
        <form onSubmit={handleSubmit} className="auth-form">
          <label>
            Username
            <input
              type="text"
              value={credentials.username}
              onChange={(event) => setCredentials({ ...credentials, username: event.target.value })}
              placeholder="admin"
            />
          </label>

          <label>
            Password
            <input
              type="password"
              value={credentials.password}
              onChange={(event) => setCredentials({ ...credentials, password: event.target.value })}
              placeholder="••••••••"
            />
          </label>

          {error ? <p className="auth-error">{error}</p> : null}

          <button type="submit" className="primary-button">Login</button>
        </form>
      </div>
    </div>
  );
}

export default AdminLogin;
